import { ApplicationUserStatus, IPagingPagingItems } from "../Common/CommonComponent";
import { ApiUtility } from "../Utilities/ApiUtility.axios";
import { Roles } from "./AuthService";

export enum ReleaseUpdateTypes {
    Unknown = 0,
    Enhancement = 1,
    New = 2,
    Fix = 3
}
export interface userDetailsProps {
    practiceId?: number;
    setLoading?: (v: any) => void;
    listParams?: any;
    setListParams?: (v: any) => void;
    pagingItems: IPagingPagingItems;
    setPagingItems: (v: any) => void;
}

export const roleOption = [
    { value: Roles.SuperAdminC, label: "Super admin" },
    { value: Roles.SubAdminC, label: "Sub admin" },
    { value: Roles.SupportUserC, label: "Support user" },
    { value: Roles.SupportManagerC, label: "Support manager" },
    { value: Roles.SupportAdminC, label: "Support admin" },
];

export const supportRoleOption = [
    { value: Roles.SupportUserC, label: "Support user" },
    { value: Roles.SupportManagerC, label: "Support manager" },
    { value: Roles.SupportAdminC, label: "Support admin" },
];

export const roleTableShow: Record<string, string> = {
    "SUPERADMIN": "Super admin",
    "SUBADMIN": "Sub admin",
    "SUPPORTUSER": "Support user",
    "SUPPORTMANAGER": "Support manager",
    "SUPPORTADMIN": "Support admin"
}
class UserService {
    route = `/Api/User`;

    getUsers = (start: number, length: any, search: string, sortCol: any, sortDir: any, practiceId: number = 0, status: ApplicationUserStatus, roles: "") =>
        ApiUtility.get(`${this.route}`, { start, length, search, sortDir, sortCol, practiceId, status, roles });

    getUserDetails = (id: string) => ApiUtility.get(`${this.route}/${id}`);

    getUserOptions = (activeOnly: boolean = false, isSupportUsers: boolean = false) => ApiUtility.get(`${this.route}/getUserOptions`, { activeOnly, isSupportUsers });

    updateUserDetails = (id: string, params: any) => ApiUtility.post(`${this.route}/Profile/${id}`, params);

    createNewUser = (params: any) => ApiUtility.post(`${this.route}`, params);

    getUserDetailsforChart = () => ApiUtility.get(`${this.route}/ChartView`);

    postImage = (id?: string, params?: any) => ApiUtility.postForm(`${this.route}/profilepicture${id ? '?id=' + id : ''}`, params);

    toggleUserStatus = (id: string, status: ApplicationUserStatus) => ApiUtility.post(`${this.route}/${id}/ToggleStatus/${status}`, "");

    resetPassword = (userId: string, newPassword?: string) =>
        ApiUtility.post(`${this.route}/ResetPassword/${userId}`, newPassword ? {
            newPassword: newPassword,
            confirmPassword: newPassword
        } : {});
}
export default new UserService();